// @react/hooks/useFiscalization.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { fiscalizationStore } from '@core/stores';

/**
 * React hook for FiscalPolicy operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useFiscalization } from '@react/hooks';
 *
 * const FiscalPolicyList = observer(() => {
 *   const store = useFiscalization();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useFiscalization() {
  return fiscalizationStore;
}
